export default () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.5C0 11.6419 3.35812 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35812 11.6419 0 7.5 0C3.35812 0 0 3.35812 0 7.5ZM7.5 2.8125C8.45344 2.8125 9.34031 3.10219 10.0809 3.59344L3.59344 10.0809C3.10219 9.34031 2.8125 8.45437 2.8125 7.5C2.8125 4.91531 4.91531 2.8125 7.5 2.8125ZM4.91899 11.4066L11.4065 4.91906C11.8977 5.66063 12.1874 6.54656 12.1874 7.5C12.1874 10.0847 10.0846 12.1875 7.49993 12.1875C6.54649 12.1875 5.66055 11.8978 4.91899 11.4066Z"
    />
  </svg>
)
